<template>
  <div class="flex">
<!--    <i class="icon" v-if="isParent && !children.length"  />-->
    <i class="icon" v-if="!isParent && !children.length"  />
    <el-input v-model="inputVal" @input="handleInputChange" :placeholder="$t('请输入')" :maxlength="inputMaxLength>0 ? inputMaxLength :''"></el-input>
    <el-link :underline="false" type="primary" class="ml8" @click="$emit('addChild', children)" v-if="showAddBtn">+ {{$t('添加子分类')}}</el-link>
  </div>
</template>

<script>
export default {
  name: "TierInput",
  model: {
    event: "input",
    prop: "value"
  },
  props: {
    value: {
      type: String,
      default: ""
    },
    children: {
      type: Array,
      default: () => []
    },
    isParent: {
      type: Boolean,
      default: false,
    },
    level: {
      type: Number,
      default: 0,
    },
    showAddBtnByLevel: {
      type: Number,
      default: 0,
    },
    selectList: {
      type: Array,
      default: () => ([])
    },
    inputMaxLength:{
      type: Number,
      default: 0,
    }
  },
  data() {
    return {
      inputVal: this.value,
    }
  },
  mounted() {
    this.$nextTick(() => {
      let iconList = document.querySelectorAll(".el-table__expand-icon>i");
      iconList.forEach(item => {
        item.classList.add("el-icon-caret-right");
      })
    })
  },
  methods: {
    handleInputChange(e) {
      this.$emit("input", e);
    },
  },
  computed: {
    showAddBtn() {
      if(!this.showAddBtnByLevel) return true;
      return this.level < this.showAddBtnByLevel;
    }
  },
}
</script>

<style scoped>

.icon {
  display: block;
  width: 10px;
  height: 16px;
  border-left: 1px solid  #969696;
  border-bottom: 1px solid #969696;
  margin-right: 10px;
}

/deep/ .cell {
  display: flex;
  align-items: center;
}

.el-link {
  flex-shrink: 0;
}

</style>
